export const selectIsFetchingBoards = ({ boards }) =>
  boards?.ui?.isFetchingBoards || false;
export const selectIsFetchingBoard = ({ boards }) =>
  boards?.ui?.isFetchingBoard || false;
export const selectIsCreatingBoard = ({ boards }) =>
  boards?.ui?.isCreatingBoard || false;
export const selectIsUpdatingBoard = ({ boards }) =>
  boards?.ui?.isUpdatingBoard || false;
